import * as api from '../api';

export const getretrieveCharities = (slug_id) => {
  const endpoint = `/projects/${slug_id}/charities`;
  return api.get(endpoint);
};
